import ApiClient from './main';

export default {
  install(app) {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$apiClient = new ApiClient();
  },
};
